import { render, staticRenderFns } from "./MarketForm.vue?vue&type=template&id=2352e7ad&scoped=true&"
import script from "./MarketForm.vue?vue&type=script&lang=js&"
export * from "./MarketForm.vue?vue&type=script&lang=js&"
import style0 from "./MarketForm.vue?vue&type=style&index=0&id=2352e7ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2352e7ad",
  null
  
)

export default component.exports